import { AnyAction } from "@reduxjs/toolkit";
import {
    BOOKING_CLEAR_EDITING_INVOICE_POSITION,
    BOOKING_CLEAR_LOADING,
    BOOKING_REMOVE_AGENT,
    BOOKING_REMOVE_DRIVER,
    BOOKING_REMOVE_DRIVER2,
    BOOKING_REMOVE_INVOICE_RECIPIENT,
    BOOKING_REMOVE_VEHICLE,
    BOOKING_SET_EDITING_INVOICE_POSITION,
    BOOKING_SET_LOADING,
    CLEAR,
    INITIALIZE_FAILED,
    INITIALIZE_START,
    INITIALIZE_SUCCESS,
    OPEN,
} from "@/Redux/Booking/Constants";
import { RootStateOrAny } from "react-redux";

interface AppState {
    initialized: boolean;
    isInitializing: boolean;
    openBookingId: number | string | null;
    booking: any;
    editingInvoicePosition: any;
    isLoadingEditingInvoicePosition: boolean;
    isLoadingStuff: boolean;
}

const initialState: AppState = {
    initialized: false,
    isInitializing: false,
    openBookingId: null,
    booking: null,
    editingInvoicePosition: null,
    isLoadingEditingInvoicePosition: true,
    isLoadingStuff: false,
};

export default function BookingReducer(
    state = initialState,
    action: AnyAction,
) {
    const booking = state.booking;

    switch (action.type) {
        case OPEN:
            return {
                ...state,
                openBookingId: action.data.openBookingId,
            };
        case CLEAR:
            return {
                ...initialState,
            };
        case BOOKING_REMOVE_INVOICE_RECIPIENT:
            booking.invoiceRecipient = null;
            return {
                ...state,
                booking: booking,
            };
        case BOOKING_REMOVE_VEHICLE:
            booking.vehicle = null;
            return {
                ...state,
                booking: booking,
            };
        case BOOKING_REMOVE_AGENT:
            booking.agent = null;
            return {
                ...state,
                booking: booking,
            };
        case BOOKING_REMOVE_DRIVER:
            booking.driver1 = null;
            return {
                ...state,
                booking: booking,
            };
        case BOOKING_REMOVE_DRIVER2:
            booking.driver2 = null;
            return {
                ...state,
                booking: booking,
            };
        case INITIALIZE_START:
            return { ...state, isInitializing: true, booking: null };
        case INITIALIZE_SUCCESS:
            return {
                ...state,
                initialized: true,
                isInitializing: false,
                booking: action.data.booking,
            };
        case INITIALIZE_FAILED:
            return {
                ...state,
                initialized: false,
                isInitializing: false,
            };
        case BOOKING_SET_EDITING_INVOICE_POSITION:
            return {
                ...state,
                isLoadingEditingInvoicePosition: false,
                editingInvoicePosition: action.data.editingInvoicePosition,
            };
        case BOOKING_CLEAR_EDITING_INVOICE_POSITION:
            return {
                ...state,
                editingInvoicePosition: null,
            };
        case BOOKING_SET_LOADING:
            return {
                ...state,
                isLoadingStuff: true,
            };
        case BOOKING_CLEAR_LOADING:
            return {
                ...state,
                isLoadingStuff: false,
            };
        default:
            return state;
    }
}

export const getState = (state: RootStateOrAny) => {
    if (typeof state.booking === "object") {
        return state.booking;
    }
    return state;
};

export const selectEditingInvoicePosition = (state: RootStateOrAny) => {
    return getState(state).editingInvoicePosition;
};

export const selectIsLoadingEditingInvoicePosition = (
    state: RootStateOrAny,
) => {
    return getState(state).isLoadingEditingInvoicePosition;
};

export const selectIsLoadingStuff = (state: RootStateOrAny) => {
    return getState(state).isLoadingStuff;
};
